import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import PlanSelectionModal from "./PlanSelectionModal";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    maxWidth: "1400px",
    width: "95%",
    borderRadius: "12px",
    padding: "0",
    backgroundColor: "#fafafa",
  },
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.8)", // Fondo más oscuro para enfatizar que es forzada
  },
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  background: "linear-gradient(135deg, #252526 0%, #404040 100%)",
  color: "white",
  padding: "20px 32px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const ForcedPlanModal = ({ open, userSubscription, onSelectPlan }) => {
  // Esta modal NO tiene onClose - no se puede cerrar
  const handleSelectPlan = (planKey) => {
    if (onSelectPlan) {
      onSelectPlan(planKey);
    }
  };

  const getModalTitle = () => {
    if (userSubscription.subscription.status === "CANCELLED") {
      return "¡Tu suscripción ha sido cancelada!";
    }
    return "¡Tu período de prueba ha expirado!";
  };

  const getModalSubtitle = () => {
    if (userSubscription.subscription.status === "CANCELLED") {
      return "Para reactivar tu cuenta, selecciona un plan que se adapte a tu negocio";
    }
    return "Para continuar usando nuestros servicios, selecciona un plan que se adapte a tu negocio";
  };
  if (
    !userSubscription?.subscription?.status ||
    (userSubscription.subscription.status !== "PENDING" && userSubscription.subscription.status !== "CANCELLED")
  ) {
    return null;
  }

  return (
    <StyledDialog
      open={open}
      // Sin onClose para que no se pueda cerrar
      disableEscapeKeyDown={true}
      maxWidth="xl"
    >
      <StyledDialogTitle>
        <Box>
          <Typography variant="h4" component="h2" sx={{ fontWeight: "bold", mb: 1, color: "#FF770D" }}>
            {getModalTitle()}
          </Typography>
          <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
            {getModalSubtitle()}
          </Typography>
        </Box>
        {/* Sin botón de cerrar */}
      </StyledDialogTitle>

      <DialogContent sx={{ padding: "40px" }}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography variant="h5" sx={{ mb: 2, color: "#252526", fontWeight: "600" }}>
            No te preocupes, sigue disfrutando de nuestros servicios
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            Selecciona el plan que mejor se adapte a tu negocio y continúa brindando el mejor servicio a tus clientes.
          </Typography>
          <Box
            sx={{
              backgroundColor: "#fff3e0",
              border: "1px solid #FF770D",
              borderRadius: "8px",
              p: 2,
              display: "inline-block",
            }}
          >
            <Typography variant="body2" sx={{ color: "#e65100", fontWeight: "600" }}>
              💡 Oferta especial: Primeros 3 meses desde $1 USD/mes
            </Typography>
          </Box>
        </Box>

        {/* Renderizar directamente el contenido de selección de planes */}
        <PlanSelectionModal
          open={true}
          onClose={() => {}} // Función vacía para evitar errores pero no permite cerrar
          onSelectPlan={handleSelectPlan}
          isForced={true} // Prop adicional para indicar que es forzada
        />
      </DialogContent>
    </StyledDialog>
  );
};

export default ForcedPlanModal;
